module.exports = __webpack_public_path__ + "fonts/font02-Bold.1b156057.woff2";